import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-verschieben';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenAufgabeVerschiebenEffects {

    AufgabeVerschieben$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_VERSCHIEBEN),
        mergeMap((x: ac.PostAufgabeVerschiebenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeVerschieben(x.aufgabeRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeVerschiebenErfolgreichAction(result, x.aufgabeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeVerschiebenFehlerAction(error, x.aufgabeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
